module.exports = __webpack_public_path__ + "static/media/phone.59aac74b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/phone.png
 ** module id = 633
 ** module chunks = 0
 **/